import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ScrollToTopOnMount from "../components/ScrollToTopOnMount.js"
import Sidebar from "../components/sidebar.js";
import { Modal, Dropdown, Nav, Tab } from 'react-bootstrap';
import Navbarinner from "../components/Navbarinner.js";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useTheme } from "../components/ThemeContext.js";
import revenue from "../assets/images/download (1).png";
import cart from "../assets/images/msg1176172984-45846-removebg-preview.png";
import balance from "../assets/images/Removal-828.png";
import PayoutCircleChart from "../components/payout-circlechart.js";
import PayoutBarChart from "../components/payout-barchart.js";
import { isEmpty } from "../helper/validation.js";
import { createBotCloseReq, getProfitData } from "../action/user.action.js";
import { toastAlert } from "../utils/toast.js";

import { getUserProfile } from "../redux/features/user/userslice.js";
import TotalProfit from "../components/shipping-software/total-profit .js";
import Footer from "../components/Footer.js";

const SoftwareAccountTypes = () => {
    const { t } = useTranslation();

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const tradingViewRef = useRef(null);
    const [stockObject, setStockObject] = useState({});
    const [show, setShow] = useState(false);
    const [profitData, setProfitData] = useState({});
    const [activeItem, setActiveItem] = useState("AMZN");
    const [isCloseBotStatus, setIsCloseBotStatus] = useState(true);
    const { theme } = useTheme();
    const user = useSelector((state) => state.account);







    const fetchProfitData = async () => {
        try {
            const { status, result, message } = await getProfitData();
            if (status) {
                setProfitData(result);
            }
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        fetchProfitData();
    }, []);

    const handleStockClick = (item) => {
        setStockObject(item)
        setActiveItem(item.symbol);
    }

    const handleCloseBot = async () => {
        try {

            let data = {
                closeStatus: isCloseBotStatus ? "ON" : "OFF"
            }
            const { status, result, message } = await createBotCloseReq(data);
            if (status) {
                toastAlert("success", t(message));
                if (!isCloseBotStatus) {
                    setIsCloseBotStatus(!isCloseBotStatus);
                }
                setShow(false);
                dispatch(getUserProfile());
            } else {
                toastAlert("error", t(message));
            }
            return;
        } catch (err) {
            console.log(err);
        }

    }
    const handleToggleChange = async (e) => {
        e.preventDefault();
        if (!e.target.checked) {
            setIsCloseBotStatus(e.target.checked);
            setShow(true);

        } else {
            setIsCloseBotStatus(e.target.checked);
            setShow(true);
        }
    }
    return (
        <>
            <div className="page_wrapper" >
                <ScrollToTopOnMount />
                <Sidebar />
                <div className="w-100" >
                    <Navbarinner />
                    <div className="right_wrapper" >
                        <div className="dashboard">
                            <div className="h_flx">
                                <h3 className="h3tag mb-0">{t("SOFTWARE_ACCOUNT_TYPES")}</h3>

                            </div>
                            {/* <TotalProfit profitData={profitData} /> */}

                            <div className="chart_flx">
                                <div className="box flex-column align-items-stretch">
                                    <div className="w-100"
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between",
                                            height: "100%",
                                        }}>
                                        <div>
                                            <h3 className="text-center">{t("STARTER_PLAN")}</h3>
                                            <h6 className="text-center mt-2">$ 100</h6>
                                            <h6 className="plan_title text-center mt-2">{t("PERFECT_FOR_BEGINNERS")}</h6>
                                            <h6 className="plan_title text-center mt-2">{t("INCLUDES")}:</h6>
                                            <ul className="stocks_list">
                                                <li>{t("LAUNCH_YOUR_FIRST_AI_DRIVEN_STORE")}</li>
                                                <li>{t("PRODUCT_RESEARCH_AI")}</li>
                                                <li>{t("AUTOMATED_ORDER_PROCESSING")}</li>
                                                <li>{t("BASIC_NICHE_SELECTION")}</li>
                                                <li>{t("STANDARD_SUPPLIER_NETWORK")}</li>
                                                <li>{t("WEEKLY_PERFORMANCE_SUMMARY")}</li>
                                                <li>{t("EMAIL_SUPPORT")}</li>
                                            </ul>
                                        </div>
                                        <div className="text-center mt-2">
                                            <button className="primary_btn">{t("SELECT_STARTER")} </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="box flex-column align-items-stretch">
                                    <div className="w-100"
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between",
                                            height: "100%",
                                        }}>
                                        <div>
                                            <h3 className="text-center">{t("GROWTH_PLAN")}</h3>
                                            <h6 className="text-center mt-2">$ 500</h6>
                                            <h6 className="plan_title text-center mt-2">{t("IDEAL_FOR_SCALING")}</h6>
                                             <h6 className="plan_title text-center mt-2">{t("INCLUDES_STARTER_PLUS")}</h6>

                                            <ul className="stocks_list">
                                                {/* <li>Minimum Deposit</li> */}
                                                <li>{t("MULTIPLE_STORE_AUTOMATION")}</li>
                                                <li>{t("AI_AD_COPY_GENERATOR")}</li>
                                                <li>{t("DYNAMIC_PRICING_TOOLS")}</li>
                                                <li>{t("ADVANCED_NICHE_PRODUCT_TARGETING")}</li>
                                                <li>{t("PRIORITY_SUPPLIER_ACCESS")}</li>
                                                <li>{t("DEDICATED_SUCCESS_MANAGER")}</li>
                                                <li>{t("WEEKLY_MARKET_TREND_INSIGHTS")}</li>

                                            </ul>
                                        </div>
                                        <div className="text-center mt-2">
                                            <button className="primary_btn">{t("SELECT_GROWTH")} </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="box flex-column align-items-stretch">
                                    <div className="w-100"
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between",
                                            height: "100%",
                                        }}>
                                        <div>
                                            <h3 className="text-center">{t("PRO_PLAN")}</h3>
                                            <h6 className="text-center mt-2">$ 1000</h6>
                                            <h6 className="plan_title text-center mt-2">{t("ALL_IN_ONE_SYSTEM")} </h6>
                                            <h6 className="plan_title text-center mt-2">{t("INCLUDES_GROWTH_PLUS")} </h6>

                                            <ul className="stocks_list">
                                                <li>{t("UNLIMITED_STORE_INTEGRATION")}</li>
                                                <li>{t("FULL_FUNNEL_AUTOMATION")}</li>
                                                <li>{t("AI_COMPETITOR_TRACKING")}</li>
                                                <li>{t("CUSTOM_BRANDING_PRODUCT_BUNDLING")}</li>
                                                <li>{t("VIP_SUPPLIER_DEALS_FAST_SHIPPING")}</li>
                                                <li>{t("BIWEEKLY_STRATEGY_SESSIONS")}</li>
                                                <li>{t("PREMIUM_SUPPORT_24_7")}</li>

                                            </ul>
                                        </div>
                                        <div className="text-center mt-2">
                                            <button className="primary_btn">{t("SELECT_PRO")} </button>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                      <div>
    <Footer />
  </div>
                </div>
            </div>
          
            <Modal show={show} centered size="sm" className="custom_modal" >
                <Modal.Header className="mb-3"  >
                    <div className="cursor-pointer" >
                        <h6>{!isCloseBotStatus ? t("ARE_YOU_SURE_WANT_TO_CLOSE_BOT") : t("ARE_YOU_SURE_WANT_TO_OPEN_BOT")}?</h6>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <button class="secondary_btn" style={{ backgound: "none !important" }} onClick={() => {
                        setIsCloseBotStatus(user?.botCloseStatus === "OFF" ? false : true);
                        setShow(false)
                    }} > {t("CANCEL")}
                    </button>
                    &nbsp; &nbsp;
                    <button class="primary_btn" onClick={handleCloseBot} > {t("CONFIRM")}
                    </button>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default SoftwareAccountTypes;